import { Button, Col, Colors, IcPlus, Row, Text } from 'basic-ui-lib';
import DragDropPlaylist from 'modules/playlist/screens/Create/ScreenPlaylist/DragDropPlaylist';
import styled from 'styled-components';
import convertNumberToSeconds from 'utils/convertNumberToSeconds';
import { ContentModal, useContentModalRef } from '../ContentModal';
import { useDraggable } from '@dnd-kit/core';
import { useMemo } from 'react';
import { Form } from 'antd';
import { ScreenFormValues } from '../ScreenForm';
import { IContentItem } from 'modules/playlist/interfaces/api';
import { IMediaItem, MediaType } from 'modules/media/interfaces/api';
import getVideoDuration from 'utils/getVideoDuration';
import { isMp4Url } from 'utils/getYoutubeId';

const ZoneListPlaylist = () => {
  const form = Form.useFormInstance<ScreenFormValues>();
  const contentModalRef = useContentModalRef();
  const contentItems = Form.useWatch('contentItems', form) || [];

  const { setNodeRef } = useDraggable({
    id: 'SCREEN_DROP_ZONE',
    data: { type: 'PLAYLIST' },
  });

  const totalDuration = useMemo(() => {
    return contentItems.reduce((sum: number, item: IContentItem) => sum + (item?.duration || 0), 0);
  }, [contentItems]);

  const handleZoneClick = () => {
    const currentContentItems = form.getFieldValue('contentItems') || [];
    contentModalRef.current?.show(currentContentItems, (content: IMediaItem[]) => {
      handleContentSelect(content);
    });
  };

  const handleContentSelect = async (content: IMediaItem[]) => {
    const contentItems = await Promise.all(
      content.map(async (c, index) => ({
        url: c.url,
        type: c.type,
        duration: (c.type === MediaType.VIDEO || (c.type === MediaType.FILE && isMp4Url(c.url))) ? await getVideoDuration(c.url) : c.duration || 0,
        indexPlay: index,
        name: c.name,
        id: c.id,
      })),
    );

    form.setFieldsValue({ contentItems });
  };

  return (
    <>
      <Row padding='0 16px' justifyContent='space-between'>
        <Col gap={0}>
          <Text body_1 regular color='neutral.text.3' left>
            Total Duration:
          </Text>
          <Text title_h5 medium left>
            {convertNumberToSeconds(totalDuration)}
          </Text>
        </Col>
        <Button
          type_new
          lg
          prefix={<IcPlus width={20} height={20} fill={Colors.primary[5]} />}
          onClick={() => handleZoneClick()}
        >
          Add Content
        </Button>
      </Row>
      <Content ref={setNodeRef}>
        <DragDropPlaylist />
      </Content>
      <ContentModal ref={contentModalRef} />
    </>
  );
};

export default ZoneListPlaylist;

const Content = styled.div`
  padding: 0 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;
